"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowFieldsDisplayGrid = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_messages_1 = require("@tableau/catalog-messages");
const catalog_queries_1 = require("@tableau/catalog-queries");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const NumberCellFormatter_1 = require("../datagrid/cellFormatters/NumberCellFormatter");
const QueryPreservingLinkCellFormatter_1 = require("../datagrid/cellFormatters/QueryPreservingLinkCellFormatter");
const RemoteTypeIcon_1 = require("../datagrid/cellFormatters/RemoteTypeIcon");
const SvgFieldIcon_1 = require("../field/components/SvgFieldIcon");
const FieldNameMapping_1 = require("../field/functions/FieldNameMapping");
const LabelsHookHelper_1 = require("../Labels/LabelsHookHelper");
function columns(siteUrls) {
    const columns = [
        () => (0, data_catalog_shared_1.createSelectionColumn)(),
        (sortParams) => ({
            name: 'type',
            dataKey: data_catalog_shared_1.UnsortableColumnKey,
            headerText: catalog_messages_1.Messages.GridHeaderType(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams),
            cellFormatter: (0, data_catalog_shared_1.createIconCellFormatter)(({ fieldIcon, remoteType }) => remoteType ? react_1.default.createElement(RemoteTypeIcon_1.RemoteTypeIcon, { remoteType: remoteType }) : react_1.default.createElement(SvgFieldIcon_1.SvgFieldIcon, { fieldIcon: fieldIcon }), ({ fieldIcon, remoteType }) => remoteType ? data_catalog_shared_1.RemoteTypeMappings[remoteType]() : fieldIcon ? FieldNameMapping_1.FieldNameMappings[fieldIcon]() : ''),
            sortable: false,
            resizable: false,
        }),
        () => createLabelGridColumnFormatter(siteUrls, 'WARNING'),
        (sortParams) => ({
            name: 'name',
            dataKey: catalog_queries_1.FieldOrderField.NAME,
            headerText: catalog_messages_1.Messages.GridHeaderName(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams),
            cellFormatter: (0, QueryPreservingLinkCellFormatter_1.createQueryPreservingReplacingLinkCellFormatter)(({ name }) => name || '', (urls, { id, flowVizportalUrlId }) => urls.flowLineageFieldPath(flowVizportalUrlId, id)),
            sortable: true,
        }),
        (sortParams) => ({
            name: 'sheets',
            dataKey: data_catalog_shared_1.UnsortableColumnKey,
            headerText: catalog_messages_1.Messages.GridHeaderSheets(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams, 'right'),
            cellFormatter: (0, NumberCellFormatter_1.createNumberCellFormatter)(({ sheetCount }) => sheetCount),
            sortable: false,
        }),
        () => createLabelGridColumnFormatter(siteUrls, 'SENSITIVITY'),
    ];
    return columns.filter(Boolean);
}
function FlowFieldsDisplayGrid(props) {
    const { customSensitivityLabelsEnabled } = (0, catalog_core_1.useFeatureFlags)();
    const urls = (0, catalog_core_1.useSiteUrls)();
    const cols = columns(urls)
        .map(columnFactory => columnFactory(props))
        .filter(column => {
        if ((column.name === 'label-sensitivity' || column.name === 'label-warning') && !customSensitivityLabelsEnabled) {
            return false;
        }
        return true;
    });
    return (react_1.default.createElement(data_catalog_shared_1.ExplorerStyledDisplayGrid, { columns: cols, rowStore: props.rowStore, selectedKeys: props.selectedKeys, updateSelectionForKey: props.updateSelectionForKey, rowCount: props.rowCount, renderErrors: data_catalog_shared_1.reportGraphQLErrors, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }));
}
exports.FlowFieldsDisplayGrid = FlowFieldsDisplayGrid;
function getLabelContentFromRowData(rowData) {
    var _a;
    const contentParams = {
        contentId: rowData.id,
        contentType: null,
        contentName: (_a = rowData.name) !== null && _a !== void 0 ? _a : undefined,
        subjectArea: rowData.typeName === 'FlowFieldOutputField' ? 'FlowFieldOutputField' : 'FlowColumnOutputField',
    };
    return contentParams;
}
function createLabelGridColumnFormatter(urls, category) {
    function getPropsFromRowData(rowData) {
        const content = getLabelContentFromRowData(rowData);
        const labels = rowData.labels ? rowData.labels : [];
        return (0, LabelsHookHelper_1.getLabelParamsForGrids)({ category, labels, urls, source: 'flow-fields', content });
    }
    return (0, data_catalog_shared_1.createLabelColumnFormatter)((0, LabelsHookHelper_1.labelCategoryToString)(category), {
        overrides: {},
        getPropsFromRowData,
    });
}
//# sourceMappingURL=FlowFieldsDisplayGrid.js.map